import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted, computed, watch, watchEffect } from "vue";
import {
  encryptionRecommMatch,
  encryptionTypeHostRecommHotPlay,
  encryptionTxtShuff,
  encryptionLiveRecordList,
  HostRecommNew
} from "@/api/php/home";
import {
  MatchCheckHost,
} from "@/api/php/player";

import { Match } from "@/model/Match";
import zhibo from "@/assets/images/bofang_icon.png";
import dayjs from "dayjs";
import { useRouter } from "vue-router";
import EventBus from "@/uitls/EventBus";
import { nativeToNewWeb, toLocationBrowser } from "@/uitls/native";
import { matchListTime, uitlsToLiveRoom } from "@/uitls/uitls";
import MatchCell from "@/components/home/MatchCell.vue"

import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'Populartoday',
  props: {
    categoryType: { type: Number, required: false }
  },
  emits: ["getalldata", "tabscr", "jumpToSport"],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  categoryType?: number,
}

const { t } = useI18n()
const host_tag = require(`@/assets/${process.env.VUE_APP_NAME}/home_host_tag.png`)

const router = useRouter();



const homeCategoryType_vi = ref();

//房间数据
const liveData = ref([])

const hasReqData = ref(false)

const countryCode = process.env.VUE_APP_NAME;

const showMatch = computed(() =>{
  
  const str = process.env.VUE_APP_SHOW_MATCH as string;
   
  return (process.env.VUE_APP_SHOW_MATCH as string) == 'true';
});

onMounted(() => {
  getalldata();
});

let stlogin = ref({
  frequency: 0,
  title: "Populartoday",
});

function getalldata() {
  getData();
  getCloumnTextBanner();

  if(countryCode == 'vi'){
    getRoomData();
  }else{
    //热门
    getHotPlay();
    //回放
    getLiveList();
  }

}

onUnmounted(() => {

})

EventBus.autoOn("refreshHomeLive", () => {
  if(countryCode == 'vi'){
      //获取越南版斗鸡数据
      getRoomData();
    }else{
      getHotPlay();
      getLiveList();
    }
});

// EventBus.autoOn("changeViCategory", (type) =>{
//   homeCategoryType_vi.value = type;
//   getRoomData();
//   console.log("收到了一次监听changeViCategory事件");
// });

expose({ getalldata });

function stloginadd() {
  stlogin.value.frequency = stlogin.value.frequency + 1;
  // 请求完成，传给父组件
  // if (stlogin.value.frequency >= 3) {
  emit("getalldata", stlogin);
  stlogin.value.frequency = 0;
  // }
}

let todaydata = ref([]);
let cloumnBanner = ref([]);
let hotPlayData = ref([]); // 正在热播
let hotPlaybackList = ref([]) // 回放
let curPage = ref(1);
const pageLimit = 10;
let loading = ref(false);
let finished = ref(false);
let refreshing = ref(false);

const getData = async () => {
  //   今日热门
  const res: any = await encryptionRecommMatch();

  // res.data.list.forEach(item => {
  //   item['live_type'] = '2';
  //   console.log('host', item.host);
  //   if (item.host && item.host.length > 0) {
  //     for (let i = 0; i < item.host.length; i++) {
  //       item.host[i]['live_type'] = '1';
  //       item['live_type'] = '1';
  //     }
  //   }


  // });
  console.log('encryptionRecommMatch', res);

  if (res.code == 200) {
    if (res.data && res.data.length) {
      res.data.forEach(item => {
        item['live_type'] = '2';
        if (item.host && item.host.length > 0) {
          for (let i = 0; i < item.host.length; i++) {
            item.host[i]['live_type'] = '1';
            item['live_type'] = '1';
          }
        }
      });
    }
    
    todaydata.value = res.data;
    stloginadd();
  }
};

const getHotPlay = async () => {
  if (!loading.value) {
    loading.value = true;
    console.log('load curpage', curPage.value);
    
    // 正在热播
    const res: any = await encryptionTypeHostRecommHotPlay({ page: curPage.value, limit: pageLimit });
    if (res.code == 200 && res.data) {
      hotPlayData.value = hotPlayData.value.concat(...res.data.list);
      finished.value = hotPlayData.value.length >= res.data.total;
      stloginadd();
    }

    loading.value = false;
    refreshing.value = false;
  }
};

const getLiveList = async () => {
  const record: any = await encryptionLiveRecordList(1);
  if (record.code == 200 && record.data) {
    hotPlaybackList.value = record.data;
  }
}

const getRoomData = async () => {
    if(homeCategoryType_vi.value == undefined){
      return;
    }
    
    const res: any = await HostRecommNew({
        type: homeCategoryType_vi.value,
        is_has_video: 0
    })
    if (res.code == 200 && res.data) {
      
        console.log(res.data);
        hasReqData.value = true;
        let list = res.data.list || [];
        if (res.data.top_list) {
            list.unshift(res.data.top_list)
        }
        hotPlayData.value = list;
    }
    loading.value = false;
    refreshing.value = false;
    
}
const onLoad = () => {
  if(countryCode == 'vi'){
    return;
  }
  console.log('on Loading', loading.value);
  if (!loading.value) {
    curPage.value++;
    getHotPlay();
  }
}

const onRefresh = () => {
  // refreshing.value = false;
  if (!loading.value) {
    curPage.value = 1;
    hotPlayData.value = [];

    if(countryCode == 'vi'){
      //获取越南版斗鸡数据
      getRoomData();
    }else{
      getHotPlay();
      getLiveList();
    }
    
  }
}

//获取文字垂直轮播的数据
const getCloumnTextBanner = async () => {
  const res: any = await encryptionTxtShuff();
  if (res && res.code == 200) {
    cloumnBanner.value = res.data;
  }
}


const toLiveRoom = async (data) => {
  const val: any = await MatchCheckHost({
    match_type: data.type_id,
    match_id: data.id,
  });

  console.log('toLiveRoom', val);


  if (val.code == 200 && val.data && val.data != 0) {
    data.live_type = 1;
    data.id = val.data;
  }

  uitlsToLiveRoom(data, router)
};

//点击了公告
const onNotice = (data) => {
  console.log(data);
  const type = data.jump_type;
  if (type == 1) {
    toLocationBrowser(data.jump_url)
    // window.location.href = data.jump_url;
  } else if (type == 2) {
    nativeToNewWeb(router, `/player?id=${data.jump_room_id}`)
    // router.push(`/player?id=${data.jump_room_id}`);
  } else if (type == 3) {
    nativeToNewWeb(router, `/player?matchType=${data.type_id}&&matchId=${data.jump_event_id}`)
    // router.push(`/player?matchType=${data.type_id}&&matchId=${data.jump_event_id}`);
  } else if (type == 99) {
    nativeToNewWeb(router, `/NewsDetail?id=${data.new_content.id}`)
    // router.push(`/NewsDetail?id=${data.new_content.id}`);
  }
}

const jumpToSport = () =>{
  emit('jumpToSport');
}


watchEffect(() =>{
  
  if(props.categoryType){
    console.log("categoryType 改变了，去调接口,categor=" + props.categoryType);
    homeCategoryType_vi.value = props.categoryType;
    getRoomData();
  }
});


const __returned__ = { t, host_tag, router, emit, props, homeCategoryType_vi, liveData, hasReqData, countryCode, showMatch, stlogin, getalldata, stloginadd, todaydata, cloumnBanner, hotPlayData, hotPlaybackList, curPage, pageLimit, loading, finished, refreshing, getData, getHotPlay, getLiveList, getRoomData, onLoad, onRefresh, getCloumnTextBanner, toLiveRoom, onNotice, jumpToSport, Match, zhibo, dayjs, nativeToNewWeb, matchListTime, MatchCell }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})